module.exports = __webpack_public_path__ + "static/media/etron_m.31642acd.pdf";